import { useNavigate } from 'react-router-dom';

function useUpdateUrlParams() {
  const navigate = useNavigate();

  const updateUrlParams = (params: Record<string, string>) => {
    const currentUrl = new URL(window.location.href);
    Object.entries(params).forEach(([key, value]) => {
      currentUrl.searchParams.set(key, value);
    });
    navigate(`${currentUrl.pathname}?${currentUrl.searchParams.toString()}`);
  };

  return updateUrlParams;
}

export default useUpdateUrlParams;
